import { $t } from '@/i18n';
import { Modal } from 'ant-design-vue';
import {
  XySourceSelectorMeta,
  XySourceActionEditMeta,
  XyHttpRequestConfigMeta,
} from '../paramsFormComponents';
import workflow from './workflow';
import qs from 'query-string';
import fetch from '../../../utils/fetch';
import { CATEGORY } from './const';


// (废弃): 改用数据源的刷新列表行为
export const refreshAtom = {
  id: 'xyEvent:w:refresh',
  name: $t('k_8ac9756d'),
  category: CATEGORY.DATASOURCE,
  visible: false,
  async execute(ctx) {
    const { rootContext } = ctx.renderer;  // xy 上下文
    rootContext.emitComponentEvent('w:refresh');
  },
};
// (旧版)从数据源重新拉数据
export const loadDataAtom = {
  id: 'xy:source:loadData',
  name: $t('k_7e337e20'),
  visible: false,
  category: CATEGORY.DATASOURCE,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'sourceId',
        type: 'string',
        title: $t('k_6e87ec70'),
        ui: { type: 'XySourceSelector' },
      },
    ],
  },
  paramsFormComponents: [
    XySourceSelectorMeta,
  ],
  async execute(ctx, params) {
    const { sourceId } = params;
    const sourceController = ctx.renderer.sources[sourceId];

    const ans = await sourceController.loadData();
    return ans;
  },
};
// (旧版)提交修改到数据源
export const submitAtom = {
  id: 'xy:source:submit',
  name: $t('k_4ee37630'),
  visible: false,
  category: CATEGORY.DATASOURCE,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'sourceId',
        type: 'boolean',
        title: $t('k_6e87ec70'),
        ui: { type: 'XySourceSelector' },
      },
      {
        id: 'actionType',
        type: 'string',
        title: $t('k_cab25464'),
        enum: [
          { label: $t('k_cb7b2f5f'), value: 'upsert' },
          { label: $t('k_9307b9ba'), value: 'createSingle' },
          { label: $t('k_9ecfbaa8'), value: 'updateSingle' },
          { label: $t('k_99303c22'), value: 'deleteSingle' },
          { label: $t('k_ac1b0a9d'), value: 'updateList' },
        ],
      },
      {
        id: 'reloadData',
        type: 'boolean',
        title: $t('k_4cbd990b'),
        default: true,
      },
    ],
  },
  paramsFormComponents: [
    XySourceSelectorMeta,
  ],
  async execute(ctx, params) {
    const { sourceId, actionType, reloadData } = params;
    const sourceController = ctx.renderer.sources[sourceId];

    const ans = await sourceController[actionType]();
    if (!ans || ans.code !== 200) {
      const errMsg = $t('k_9f967bfb', { arg_0: ans?.code, arg_1: ans?.message || ans?.error });
      Modal.error({
        title: $t('k_35beaf82'),
        content: errMsg,
      });
      throw new Error(errMsg);
    }

    if (reloadData) await sourceController.loadData();
    return ans.data;
  },
  returnValue: $t('k_887aff3f'),
};
// (旧版)审批驳回
export const approveRejectAtom = {
  id: 'xy:source:approveReject',
  name: $t('k_8660c77a'),
  category: CATEGORY.WORKFLOW,
  visible: false,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'sourceId',
        type: 'string',
        title: $t('k_6e87ec70'),
        ui: { type: 'XySourceSelector' },
      },
      {
        id: 'comment',
        type: 'string',
        title: $t('k_b18fa4f2'),
      },
    ],
  },
  paramsFormComponents: [
    XySourceSelectorMeta,
  ],
  async execute(ctx, params) {
    const result = await workflow.transition(ctx, params, 'reject');
    return result;
  },
};
// (旧版)审批同意
export const approvePassAtom = {
  id: 'xy:source:approvePass',
  name: $t('k_7737216e'),
  category: CATEGORY.WORKFLOW,
  visible: false,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'sourceId',
        type: 'string',
        title: $t('k_6e87ec70'),
        ui: { type: 'XySourceSelector' },
      },
    ],
  },
  paramsFormComponents: [
    XySourceSelectorMeta,
  ],
  async execute(ctx, params) {
    const result = await workflow.transition(ctx, params, 'pass');
    return result;
  },
};
// (旧版)发起流程
export const workflowStartAtom = {
  id: 'xy:source:workflowStart',
  name: $t('k_5628bc7e'),
  category: CATEGORY.WORKFLOW,
  visible: false,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'sourceId',
        type: 'string',
        title: $t('k_6e87ec70'),
        ui: { type: 'XySourceSelector' },
      },
      {
        id: 'objectId',
        type: 'string',
        title: $t('k_2c3ea8e7'),
      },
    ],
  },
  paramsFormComponents: [
    XySourceSelectorMeta,
  ],
  async execute(ctx, params) {
    const result = await workflow.start(ctx, params);
    return result;
  },
};
// 审批同意(废弃)
export const approvePassV2Atom = {
  id: 'xy:source:approvePassV2',
  name: $t('k_7c8c3d01'),
  category: CATEGORY.WORKFLOW,
  visible: false,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'entityId',
        type: 'string',
        title: $t('k_46b126e8'),
      },
      {
        id: 'currentStatus',
        type: 'string',
        title: $t('k_9e304f99'),
      },
      {
        id: 'payload',
        type: 'string',
        title: $t('k_d9f05628'),
      },
      {
        id: 'comment',
        type: 'string',
        title: $t('k_b18fa4f2'),
      },
    ],
  },
  paramsFormComponents: [
  ],
  async execute(ctx, params) {
    const { entityId, currentStatus, comment, payload } = params;
    if (!entityId) {
      throw new Error($t('k_9ab62ea7'));
    }
    const { wContext: { config: { projectId }, env } } = ctx.renderer;
    try {
      const result = await workflow.transitionWithId(
        projectId,
        env,
        entityId,
        { operation: 'pass', currentStatus, comment, payload },
      );
      return result;
    } catch (error) {
      throw new Error($t('k_c38db77e', { arg_0: error.message }));
    }
  },
};
// 审批驳回(废弃)
export const approveRejectV2Atom = {
  id: 'xy:source:approveRejectV2',
  name: $t('k_4a3f0b62'),
  category: CATEGORY.WORKFLOW,
  visible: false,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'entityId',
        type: 'string',
        title: $t('k_46b126e8'),
      },
      {
        id: 'currentStatus',
        type: 'string',
        title: $t('k_9e304f99'),
      },
      {
        id: 'payload',
        type: 'string',
        title: $t('k_d9f05628'),
      },
      {
        id: 'comment',
        type: 'string',
        title: $t('k_b18fa4f2'),
      },
    ],
  },
  paramsFormComponents: [
  ],
  async execute(ctx, params) {
    const { entityId, comment, currentStatus, payload } = params;
    if (!entityId) {
      throw new Error($t('k_9ab62ea7'));
    }
    const { wContext: { config: { projectId }, env } } = ctx.renderer;
    const result = await workflow.transitionWithId(
      projectId,
      env,
      entityId,
      { operation: 'reject', currentStatus, comment, payload },
    );
    return result;
  },
};
// 发送HTTP请求被数据源调用代替，默认下线该行为原子
export const invokeHttpRequestAtom = {
  id: 'xyEvent:invokeHttpRequest',
  name: $t('k_f14ee314'),
  category: CATEGORY.DATASOURCE,
  desc: $t('k_94c37ee5'),
  visible: false,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'method',
        type: 'string',
        title: $t('k_70f6fcda'),
        enum: [
          { label: 'GET', value: 'GET' },
          { label: 'POST', value: 'POST' },
          { label: 'DELETE', value: 'DELETE' },
          { label: 'PUT', value: 'PUT' },
          { label: 'HEAD', value: 'HEAD' },
          { label: 'OPTIONS', value: 'OPTIONS' },
          { label: 'PATCH', value: 'PATCH' },
        ],
      },
      {
        id: 'url',
        type: 'string',
        title: 'URL',
      },
      {
        id: 'content',
        type: 'object',
        title: '',
        'uc:allowInterop': true,
        ui: { type: 'XyHttpRequestConfig' },
        fields: [{
          id: 'headers',
          type: 'array',
          items: {
            type: 'object',
            fields: [
              { id: 'name', type: 'string' },
              { id: 'content', type: 'string' },
            ],
          },
          default: [],
        }, {
          id: 'body',
          type: 'string',
          default: '{}',
        }, {
          id: 'querys',
          type: 'array',
          items: {
            type: 'object',
            fields: [
              { id: 'name', type: 'string' },
              { id: 'content', type: 'string' },
            ],
          },
        }],
      },
      {
        id: 'withCredentials',
        type: 'boolean',
        title: $t('k_df74607c'),
        default: false,
      },
      {
        id: 'timeout',
        type: 'number',
        title: $t('k_8449f277'),
        default: true,
        default: 60000,
      },
      {
        id: 'errorText',
        type: 'string',
        title: $t('k_9f485e2d'),
        default: true,
        default: '',
      },
    ],
  },
  paramsFormComponents: [
    XyHttpRequestConfigMeta,
  ],
  returnValue: $t('k_bf5703b2'),
  async execute(ctx, params) {
    const { method, url, content, withCredentials, timeout, errorText } = params;
    const { headers, body, querys } = content;
    let requestUrl = url;
    if (querys) {
      const querysObj = querys.reduce((obj, query) => ({ ...obj, [query.name]: [query.content] }), {});
      const querysString = qs.stringify(querysObj);
      if (querysString) requestUrl += `?${querysString}`;
    }
    try {
      const headerObj = headers.reduce((obj, item) => ({ ...obj, [item.name]: item.content }), {});
      const result = await fetch(
        requestUrl, Object.assign({
          method,
          headers: headerObj,
          credentials: withCredentials ? 'include' : 'omit',
        }, (method === 'HEAD' || method === 'GET') ? {} : { body }),
        timeout, false, false,
      );
      return result;
    } catch (err) {
      // 请求失败，流程终止
      throw new Error(errorText ? errorText : $t('k_5c48d2f7', { arg_0: err.message }));
    }
  },
};
// 数据源操作（弃用）
export const dispatchAtom = {
  id: 'xy:source:dispatch',
  name: $t('k_a845563c'),
  category: CATEGORY.DATASOURCE,
  visible: false,
  paramsSchema: {
    type: 'object',
    fields: [
      {
        id: 'action',
        type: 'any',
        title: '',
        default: { sourceId: '', action: '' },
        ui: { type: 'XySourceActionEdit' },
      },
    ],
  },
  paramsFormComponents: [
    XySourceActionEditMeta,
  ],
  async execute(ctx, params) {
    const { sourceId, action } = params.action || {};
    const sourceController = ctx.renderer.sources[sourceId];

    const ans = await sourceController.dispatch(action);
    return ans;
  },
  returnValue: $t('k_887aff3f'),
};

export default [
  refreshAtom,
  loadDataAtom,
  submitAtom,
  approveRejectAtom,
  approvePassAtom,
  workflowStartAtom,
  approvePassV2Atom,
  approveRejectV2Atom,
  invokeHttpRequestAtom,
  dispatchAtom,
];
